import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import store from './store';
import './registerCommonComponents';
import HllUI from '@/libs/hll-m-ui';
import '@/libs/mint-ui/picker/style.css';
import { Picker } from 'mint-ui';
import urlConfig from '@/config';
import Directive from '@/directive';
import '@/components/js/watchDog';
import Axios from '@/axios'; //使用axios和mock
import evtTrack from '@/components/mixins/evtTracking'; //埋点接口
import shareAct from '@/components/mixins/share'; //分享接口
import '@/libs/gt';
import '@/libs/gt/style.css';
import 'lib-flexible'; //使用vw适配时也推荐继续引入，这是一套viewport缩放方案，只是额外添加了根结点字体大小

Vue.use(VueRouter);
Vue.use(HllUI);
Vue.component(Picker.name, Picker); //地址三级选择器
Vue.use(Directive);
Vue.use(urlConfig); //要在Axios配置之前进行安装,有axios需要的baseURL依赖
Vue.use(store);
Vue.use(evtTrack);
Vue.use(shareAct);
Vue.config.productionTip = true;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

//测试相关
import VConsole from 'vconsole';
import TestMode from './testMode'; //测试模式
urlConfig.isPro || new VConsole(); // 初始化
TestMode();

export default {
  async init(router, initGlobalData, oStore = null) {
    if (oStore) {
      if ('app' in store.state) {
        //兼容vuex缓存
        oStore.state = store.state.app;
      }
      store.registerModule('app', oStore);
    }
    //挂载axios实例,使用router进行路由处理
    Vue.use(Axios, router, store);

    if (typeof initGlobalData == 'function') {
      await initGlobalData(store);
    }
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
};
